// @generated by protoc-gen-es v2.10.2 with parameter "target=js"
// @generated from file slorgproto/v1/core.proto (package slorgproto.v1, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file slorgproto/v1/core.proto.
 */
export const file_slorgproto_v1_core = /*@__PURE__*/
  fileDesc("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");

/**
 * Describes the message slorgproto.v1.DeclaredProperty.
 * Use `create(DeclaredPropertySchema)` to create a new message.
 */
export const DeclaredPropertySchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 0);

/**
 * Describes the message slorgproto.v1.ConfigDomain.
 * Use `create(ConfigDomainSchema)` to create a new message.
 */
export const ConfigDomainSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 1);

/**
 * Describes the message slorgproto.v1.Config.
 * Use `create(ConfigSchema)` to create a new message.
 */
export const ConfigSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 2);

/**
 * Describes the message slorgproto.v1.FileSystemStorageConfig.
 * Use `create(FileSystemStorageConfigSchema)` to create a new message.
 */
export const FileSystemStorageConfigSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 3);

/**
 * Describes the message slorgproto.v1.WebDAVStorageConfig.
 * Use `create(WebDAVStorageConfigSchema)` to create a new message.
 */
export const WebDAVStorageConfigSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 4);

/**
 * Describes the message slorgproto.v1.LocalStorageConfig.
 * Use `create(LocalStorageConfigSchema)` to create a new message.
 */
export const LocalStorageConfigSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 5);

/**
 * Describes the message slorgproto.v1.StorageConfig.
 * Use `create(StorageConfigSchema)` to create a new message.
 */
export const StorageConfigSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 6);

/**
 * Describes the message slorgproto.v1.SlorgIdPartsBasic.
 * Use `create(SlorgIdPartsBasicSchema)` to create a new message.
 */
export const SlorgIdPartsBasicSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 7);

/**
 * Describes the message slorgproto.v1.SlorgIdPartsBasicAlt.
 * Use `create(SlorgIdPartsBasicAltSchema)` to create a new message.
 */
export const SlorgIdPartsBasicAltSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 8);

/**
 * Describes the message slorgproto.v1.SlorgIdPartsDate.
 * Use `create(SlorgIdPartsDateSchema)` to create a new message.
 */
export const SlorgIdPartsDateSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 9);

/**
 * Describes the message slorgproto.v1.SlorgIdPartsDateAlt.
 * Use `create(SlorgIdPartsDateAltSchema)` to create a new message.
 */
export const SlorgIdPartsDateAltSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 10);

/**
 * Describes the message slorgproto.v1.SlorgId.
 * Use `create(SlorgIdSchema)` to create a new message.
 */
export const SlorgIdSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 11);

/**
 * Describes the message slorgproto.v1.SlorgIdQuery.
 * Use `create(SlorgIdQuerySchema)` to create a new message.
 */
export const SlorgIdQuerySchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 12);

/**
 * Describes the message slorgproto.v1.Repeat.
 * Use `create(RepeatSchema)` to create a new message.
 */
export const RepeatSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 13);

/**
 * Describes the message slorgproto.v1.Scheduled.
 * Use `create(ScheduledSchema)` to create a new message.
 */
export const ScheduledSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 14);

/**
 * Describes the message slorgproto.v1.Deadline.
 * Use `create(DeadlineSchema)` to create a new message.
 */
export const DeadlineSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 15);

/**
 * Describes the message slorgproto.v1.LogbookEntry.
 * Use `create(LogbookEntrySchema)` to create a new message.
 */
export const LogbookEntrySchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 16);

/**
 * Describes the message slorgproto.v1.DocumentLink.
 * Use `create(DocumentLinkSchema)` to create a new message.
 */
export const DocumentLinkSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 17);

/**
 * Describes the message slorgproto.v1.DocumentSection.
 * Use `create(DocumentSectionSchema)` to create a new message.
 */
export const DocumentSectionSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 18);

/**
 * Describes the message slorgproto.v1.Document.
 * Use `create(DocumentSchema)` to create a new message.
 */
export const DocumentSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 19);

/**
 * Describes the message slorgproto.v1.AssetInfo.
 * Use `create(AssetInfoSchema)` to create a new message.
 */
export const AssetInfoSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 20);

/**
 * Describes the message slorgproto.v1.FileSystemDocumentMetadata.
 * Use `create(FileSystemDocumentMetadataSchema)` to create a new message.
 */
export const FileSystemDocumentMetadataSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 21);

/**
 * Describes the message slorgproto.v1.FileSystemNode.
 * Use `create(FileSystemNodeSchema)` to create a new message.
 */
export const FileSystemNodeSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_core, 22);

/**
 * Describes the enum slorgproto.v1.Status.
 */
export const StatusSchema = /*@__PURE__*/
  enumDesc(file_slorgproto_v1_core, 0);

/**
 * *
 * The state of a document. Some documents can be considered
 * active. In that case, there is an action that must be taken
 * in order to advance the stages of the document.
 * See https://orgmode.org/org.html#TODO-Items-1
 *
 * @generated from enum slorgproto.v1.Status
 */
export const Status = /*@__PURE__*/
  tsEnum(StatusSchema);

/**
 * Describes the enum slorgproto.v1.Priority.
 */
export const PrioritySchema = /*@__PURE__*/
  enumDesc(file_slorgproto_v1_core, 1);

/**
 * @generated from enum slorgproto.v1.Priority
 */
export const Priority = /*@__PURE__*/
  tsEnum(PrioritySchema);

/**
 * Describes the enum slorgproto.v1.SlorgIdKind.
 */
export const SlorgIdKindSchema = /*@__PURE__*/
  enumDesc(file_slorgproto_v1_core, 2);

/**
 * @generated from enum slorgproto.v1.SlorgIdKind
 */
export const SlorgIdKind = /*@__PURE__*/
  tsEnum(SlorgIdKindSchema);

/**
 * Describes the enum slorgproto.v1.FileSystemNodeKind.
 */
export const FileSystemNodeKindSchema = /*@__PURE__*/
  enumDesc(file_slorgproto_v1_core, 3);

/**
 * @generated from enum slorgproto.v1.FileSystemNodeKind
 */
export const FileSystemNodeKind = /*@__PURE__*/
  tsEnum(FileSystemNodeKindSchema);

/**
 * Describes the enum slorgproto.v1.DocumentKind.
 */
export const DocumentKindSchema = /*@__PURE__*/
  enumDesc(file_slorgproto_v1_core, 4);

/**
 * *
 * What a document stands in for. An unspecified kind is an
 * ordinary document.
 *
 * @generated from enum slorgproto.v1.DocumentKind
 */
export const DocumentKind = /*@__PURE__*/
  tsEnum(DocumentKindSchema);

/**
 * Describes the enum slorgproto.v1.PropertyType.
 */
export const PropertyTypeSchema = /*@__PURE__*/
  enumDesc(file_slorgproto_v1_core, 5);

/**
 * *
 * How a property's value is meant to be read. An unspecified type
 * is text, matching the org file itself, where a type is recorded
 * only when it is not text.
 *
 * @generated from enum slorgproto.v1.PropertyType
 */
export const PropertyType = /*@__PURE__*/
  tsEnum(PropertyTypeSchema);

/**
 * Describes the enum slorgproto.v1.StorageBackendType.
 */
export const StorageBackendTypeSchema = /*@__PURE__*/
  enumDesc(file_slorgproto_v1_core, 6);

/**
 * @generated from enum slorgproto.v1.StorageBackendType
 */
export const StorageBackendType = /*@__PURE__*/
  tsEnum(StorageBackendTypeSchema);

/**
 * Describes the enum slorgproto.v1.RepeatKind.
 */
export const RepeatKindSchema = /*@__PURE__*/
  enumDesc(file_slorgproto_v1_core, 7);

/**
 * *
 * How a repeat advances when the document carrying it is completed.
 * The names are org's own: cumulate adds one interval to the stored
 * date and may land in the past, catch-up adds intervals until the
 * date is in the future, and restart counts from the completion.
 *
 * @generated from enum slorgproto.v1.RepeatKind
 */
export const RepeatKind = /*@__PURE__*/
  tsEnum(RepeatKindSchema);

/**
 * Describes the enum slorgproto.v1.RepeatUnit.
 */
export const RepeatUnitSchema = /*@__PURE__*/
  enumDesc(file_slorgproto_v1_core, 8);

/**
 * @generated from enum slorgproto.v1.RepeatUnit
 */
export const RepeatUnit = /*@__PURE__*/
  tsEnum(RepeatUnitSchema);

/**
 * Describes the enum slorgproto.v1.LogbookEntryKind.
 */
export const LogbookEntryKindSchema = /*@__PURE__*/
  enumDesc(file_slorgproto_v1_core, 9);

/**
 * *
 * What a LOGBOOK line records. A line the drawer carries that SLORG does
 * not model is kept verbatim as RAW rather than dropped.
 *
 * @generated from enum slorgproto.v1.LogbookEntryKind
 */
export const LogbookEntryKind = /*@__PURE__*/
  tsEnum(LogbookEntryKindSchema);

